import { render, staticRenderFns } from "./scanQr.vue?vue&type=template&id=23953e1c&scoped=true"
import script from "./scanQr.vue?vue&type=script&lang=js"
export * from "./scanQr.vue?vue&type=script&lang=js"
import style0 from "./scanQr.vue?vue&type=style&index=0&id=23953e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23953e1c",
  null
  
)

export default component.exports